/* istanbul ignore file */
/**
 * Created by rathompson on 11/3/21
 * File: InheritanceRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { Body } from '@panwds/react-ui'
import { useContext, VFC } from 'react'
import GlobalContext from '../../../../../common/context/GlobalContext'
import { LABEL_NOT_APPLICABLE } from '../../../../../common/constants/LabelConstants'
import type { RowInstance } from '@panwds/react-table'
import type { IAM_Role } from '../../../../../common/reducers/types/IAMReducer.types'

/**
 *   Permission inheritance table cell
 */
const InheritanceRenderer: VFC<{
  row: RowInstance<IAM_Role>,
  value: string
}> = ({ row, value }) => {
  const { treeReducer } = useContext(GlobalContext)
  const { sgKeyBy = {}, selectedTreeNode = {} } = treeReducer

  if (selectedTreeNode?.id !== value) {
    return (<Body size="lg" addClassName='tw-truncate'>{sgKeyBy[value]?.display_name || LABEL_NOT_APPLICABLE}</Body>)
  }
  return null
}

export default InheritanceRenderer
